import React from "react";
import { Typography, Box } from "@mui/material";
import { adminV2Theme as t } from "../theme";

export default function PlaceholderPage({ title, description }) {
  return (
    <Box>
      <Typography sx={{ fontSize: { xs: 20, sm: 22 }, fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      <Typography sx={{ color: t.colors.textMuted, fontSize: 14, maxWidth: 560 }}>
        {description ||
          "Placeholder for a later Admin Dashboard Program slice. Live hubs: Overview and Business & Finance."}
      </Typography>
    </Box>
  );
}
